<p>course-settings works!</p>
